import { array, func, string, number } from 'prop-types'
import { UnwrappedButton } from '../Button'
import Menu from '../Menu'
import Dropdown from '../PopoverV2/Dropdown'
import { kuiperClassNames } from '../utils/kuiperClassNames'

import './styles.scss'

const renderPopoverMenu = (objectName, onSelect, stamps = []) => (
  <Menu
    canSelectAll={false}
    className={kuiperClassNames(`stamp-menu-${objectName}`)}
    focusOnMount={true}
    minimumSearchLength={1}
    multiple={false}
    options={stamps}
    onSelect={(stamp) => onSelect(stamp)}
    role="listbox"
    searchable={true}
    showControls={false}
  />
)

const renderPopoverTrigger = (objectName, selectedStamp) => (
  <UnwrappedButton
    hasMenu={true}
    label={selectedStamp ? selectedStamp.title : `Apply ${objectName} Stamp`}
    position="left"
    type="secondary"
    icon="approval"
    onClick={(e) => {
      e.stopPropagation()
    }}
    size="wide"
    typeAttribute="button"
  />
)

const ApplyStampButton = ({
  objectName,
  onSelect,
  stamps,
  selectedStampId,
}) => {
  const selectedStamp = stamps.find((s) => s.id === selectedStampId)
  return (
    <Dropdown
      className={kuiperClassNames('apply-stamp-button')}
      content={renderPopoverMenu(objectName, onSelect, stamps)}
      position="bottom"
      trigger={renderPopoverTrigger(objectName, selectedStamp)}
    />
  )
}

ApplyStampButton.propTypes = {
  objectName: string,
  onSelect: func,
  stamps: array,
  selectedStampId: number,
}

export default ApplyStampButton
